import Phaser from "phaser";
import LoadingScene from "@/games/MiniGame/Kombat/scenes/LoadingScene";
import QuestionScene from "@/games/MiniGame/Kombat/scenes/QuestionScene";
import PlayScene from "@/games/MiniGame/Kombat/scenes/PlayScene";
import LandingScene from "@/games/MiniGame/Kombat/scenes/LandingScene";
import Settings from "@/games/MiniGame/Kombat/scenes/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      PlayScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
